/**
 * @license
 * Copyright 2018 JBoss Inc
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import {Component, EventEmitter, Input, Output, ViewEncapsulation} from "@angular/core";
import {CodeEditorMode} from "./code-editor.component";

@Component({
    selector: "markdown-editor",
    templateUrl: "markdown-editor.component.html",
    encapsulation: ViewEncapsulation.None
})
export class MarkdownEditorComponent {

    public _value: string;

    @Input() editorStyle: any;

    @Input()
    get value() {
        return this._value;
    }

    @Output() public valueChange = new EventEmitter<string>();
    set value(value: string) {
        this._value = value;
        this.valueChange.emit(value);
    }

    public codeEditorMode(): CodeEditorMode {
        return CodeEditorMode.Markdown;
    }

}